import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { OnboardingTask } from '../../types/Onboarding';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/onboarding', 'put'>;
type ResponseBody = OASOutput<O, '/api/onboarding', 'put'>;

type Params = {
  onboarding?: OnboardingTask;
  isFinished?: boolean | null;
};

type Result = {
  onboardingCheckList: OnboardingTask[];
  isOnboardingFinished: boolean;
};

export const updateOnboardingFactory = (apiClient: ApiClient) => {
  const updateOnboarding = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/onboarding'].put(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        onboarding: input.onboarding ?? null,
        isFinished: input.isFinished ?? null,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      onboardingCheckList: response.onboardingCheckList,
      isOnboardingFinished: response.isOnboardingFinished,
    };
  };

  return updateOnboarding;
};
